<template>
    <div>
        <h2>{{ title }}</h2>
        <br>
    </div>
</template>

<script>
export default {
    name: "header-title",
    props: {
        title: String
    }
};
</script>

<style scoped></style>
